import React from "react";
import { FaEye } from "react-icons/fa";
import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { decrypt } from "../utils";
import SelfieCaptured from "./SelfieCaptured";
import { COMPLIANCE_REJECTED } from "../utilities";



const InvestorSelfieCapture = ({
    indivInvFormData,
    onBack,
    onNext,
    setSelfieData,
    removeCompletedStep,
    handleSelfieAndLivenessChange,
    showSelfieModal,
    setShowSelfieModal,
    isSelfieDone,
    setIsSelfieDone,
    handleSaveKYCDraft,
    handleDeleteSelfieFile,
    handleViewFile,
    investorDatauser,
    livenessErrorMsg

}) => {

    const [role_code, setRoleCode] = useState(Cookies.get("role_code"));

    useEffect(() => {
        if (role_code) {
            const decryptedValueData = decrypt(role_code)
            setRoleCode(decryptedValueData);
        }
    }, [])

    useEffect(() => {
        const savedPreview = sessionStorage.getItem("kyc_selfie_preview");
        if (savedPreview) {
            setSelfieData({ preview: savedPreview });
        }
    }, []);




    const isSelfieCaptured =
        indivInvFormData?.selfie_blob_url &&
        indivInvFormData?.liveness_video_blob_url;


    const status = investorDatauser?.kyc?.[0]?.status;
    const reason = investorDatauser?.kyc?.[0]?.admin_notes;

    const truncateWords = (text, limit = 35) => {
        if (!text) return "";

        if (text.length <= limit) return text;

        return text.substring(0, limit) + "...";
    };

    const renderKycStatus = () => {
        if (!investorDatauser?.kyc) return null;


        // if (reason) {
                if (investorDatauser?.kyc?.[0]?.status === COMPLIANCE_REJECTED) {
        
            return (
                <div className="kyc-status kyc-status-rejected">
                    <div>Status: Rejected</div>

                    <div className="kyc-reason">
                        Reason:
                        <span title={reason}
                            style={{ fontSize: "15px" }}>
                            {truncateWords(reason, 35)}
                        </span>
                    </div>
                </div>
            );
        }


        return null;
    };



    return (


        <div className="kyc-poppins-ui">
            <div className="main-content">
                <div className="content-wrapper">

                    <div className="review-header-row">
                        <div class="step-header">
                            <div class="step-title"> Verify it's really you</div>
                            <div class="step-subtitle">Take a quick video to confirm your identity matches your ID.</div>
                        </div>
                        <div className="review-status">
                            {renderKycStatus()}
                        </div>
                    </div>

                    <>
                        <div className="camera-instructions">
                            <strong style={{ display: "block", marginBottom: "8px" }}>
                                Tips for a great selfie:
                            </strong>
                            ✓ Remove glasses or hat<br />
                            ✓ Ensure good lighting on your face<br />
                            ✓ Look directly at the camera<br />
                            ✓ Keep a neutral expression
                        </div>
                    </>

                    {/* {(isSelfieCaptured) && ( */}

                    {!isSelfieCaptured && (
                        <div className="text-danger small mt-1">
                            {livenessErrorMsg}
                        </div>
                    )}
                    {/* )} */}


                    {!isSelfieCaptured && (
                        <button
                            className="btn btn-primary"
                            onClick={() => setShowSelfieModal(true)}
                        >
                            Open Camera
                        </button>
                    )}



                    {(isSelfieCaptured) && (

                        <div className="selfie-success-card small">

                            <div
                                className="file-actions"
                                onClick={(e) => e.stopPropagation()}
                            >
                                {/* VIEW */}
                                <button
                                    type="button"
                                    className="icon-btn view"
                                    title="View selfie"
                                    onClick={() => handleViewFile("selfie")}
                                >
                                    <FaEye
                                        className="eye-view-color-kyc"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"


                                    />
                                </button>

                                {/* DELETE */}
                                {/* <button
                                    type="button"
                                    className="icon-btn cancel"
                                    title="Delete selfie"
                                    onClick={() => handleDeleteSelfieFile("selfie")}
                                >
                                    ✕
                                </button> */}
                            </div>
                            <div className="success-icon">✓</div>
                            <h4>Perfect! Selfie Captured</h4>
                            <p>Your identity has been successfully verified</p>

                            <button
                                className="btn btn-link"
                                onClick={() => {
                                    setShowSelfieModal(true)
                                    setIsSelfieDone(false)
                                }}

                            >
                                Retake Photo
                            </button>
                        </div>
                    )}


                    {showSelfieModal && (
                        <SelfieCaptured
                            onCancel={() => {
                                setShowSelfieModal(false);
                                setIsSelfieDone(false);
                            }}


                            onCaptured={({ selfieFile, livenessVideo, livenessSessionId }) => {
                                handleSelfieAndLivenessChange({
                                    selfieFile,
                                    livenessVideo,
                                    livenessSessionId,
                                });
                                setShowSelfieModal(false)
                                setIsSelfieDone(true);
                            }}
                        />
                    )}


                    <div className="button-group">
                        <button className="btn btn-secondary" onClick={onBack}>
                            ← Back
                        </button>


                        <button
                            className="btn btn-primary"
                            disabled={!isSelfieCaptured}
                            onClick={() => {

                                handleSaveKYCDraft()
                                onNext();

                            }}
                        >
                            Continue →
                        </button>

                    </div>

                </div>
            </div>
        </div>
    );
};

export default InvestorSelfieCapture;
